export default __webpack_public_path__ + "static/media/ACM text logo.ce6ebb87.svg";